import {faTimes} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {DialogContent, DialogTitle} from '@mui/material'
import React, {Component, ReactNode} from 'react'
import styled from 'styled-components'
import {UnstyledLinkStyledButton} from '../../../../../styledComponents/Button'
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {Colors, FontFamily, FontWeights} from '../../../../../styledComponents/Constants'
import NatDisasterCommentInputForm, {DisasterCommentFile} from './NatDisasterCommentInputForm'
import {Nullable, Optional} from '../../../../../app/TypeHelpers'
import ResponsiveDialog from '../../../../../components/shared/ResponsiveDialog'
import {currentMedia} from '../../../../../styledComponents/ResponsiveConvenience'
import {NatPostDisasterCommentFileUploadRequest} from '../../repository/NatPostDisasterCommentFileUpload'
import {NatPutDisasterCommentRequest} from '../../repository/NatPutDisasterComment'
import {VIEW_DO_OR_NOT} from '../../../../../CodeMaster'
import {InputError} from './NatDisasterCommentError'

interface Props {
    open: boolean
    commentId: number
    version: number
    comment: string
    posterNamePrivateFlag: boolean
    commentFileList: DisasterCommentFile[]
    deleteFileNumberList: number[]
    onClickEditCanselButton: () => void
    onClickEditButton: (
        commentRequest: NatPutDisasterCommentRequest,
        fileRequests: NatPostDisasterCommentFileUploadRequest[]
    ) => Promise<Nullable<InputError>>
}

interface State {
    comment: string
    posterNamePrivateFlag: boolean
    newCommentFileList: DisasterCommentFile[]
    deleteFileNumberList: number[]
    inputError: Optional<InputError>
}

class NatDisasterCommentEditDialog extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            comment: this.props.comment,
            posterNamePrivateFlag: this.props.posterNamePrivateFlag,
            newCommentFileList: this.props.commentFileList,
            deleteFileNumberList: [],
            inputError: undefined
        }
    }

    handleClickRegisterReplyButton = async () => {
        const {version} = this.props
        const {comment, posterNamePrivateFlag, deleteFileNumberList} = this.state

        const request: NatPutDisasterCommentRequest = {
            comment: comment,
            posterNamePrivateFlag: posterNamePrivateFlag ? VIEW_DO_OR_NOT.HIDDEN.value : VIEW_DO_OR_NOT.DISPLAY.value,
            deleteCommentFile: deleteFileNumberList.map(file => {
                return {seq: file}
            }),
            version: version
        }
        const fileRequests: NatPostDisasterCommentFileUploadRequest[] =
            this.state.newCommentFileList.filter(file => !file.fileNumber).map(file => {
                const data: string[] = String(file.fileData).split(',')
                return {
                    fileName: file.fileName,
                    fileData: data[1]
                }
            })

        const inputError = await this.props.onClickEditButton(request, fileRequests)
        if (inputError && !inputError.fileNameList) {
            this.setState({inputError: inputError})
        } else {
            this.props.onClickEditCanselButton()
        }
    }

    handleClickCloseCommentInputButton = (): void => {
        this.props.onClickEditCanselButton()
    }

    handleChangeCommentInput = (
        comment: string,
        posterNamePrivateFlag: boolean,
        commentFileList: DisasterCommentFile[],
        deleteFileNumberList: number[],
        inputError?: InputError
    ): void => {
        this.setState({
            comment: comment,
            posterNamePrivateFlag: posterNamePrivateFlag,
            newCommentFileList: [...commentFileList],
            deleteFileNumberList: deleteFileNumberList,
            inputError: inputError
        })
    }

    render(): ReactNode {
        return (<>
            <CommentEditDialog
                open={this.props.open}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
            >
                <StyledDialogTitle>
                    <RowFlexContainer>
                        コメント編集
                        <UnstyledLinkStyledButton
                            id={'closeButton'}
                            onClick={this.handleClickCloseCommentInputButton}
                        >
                            <FontAwesomeIcon icon={faTimes} size={'lg'}/>
                        </UnstyledLinkStyledButton>
                    </RowFlexContainer>
                </StyledDialogTitle>
                <StyledDialogContent>
                    <NatDisasterCommentInputForm
                        id={`edit-${this.props.commentId}`}
                        submitButtonLabel={`完了`}
                        clearButtonLabel={'キャンセル'}
                        onClickSubmitButton={this.handleClickRegisterReplyButton}
                        onClickCancelButton={this.handleClickCloseCommentInputButton}
                        onChange={this.handleChangeCommentInput}
                        comment={this.state.comment}
                        posterNamePrivateFlag={this.state.posterNamePrivateFlag}
                        commentFileList={this.state.newCommentFileList}
                        deleteFileNumberList={this.state.deleteFileNumberList}
                        inputError={this.state.inputError}
                    />
                </StyledDialogContent>
            </CommentEditDialog>
        </>)
    }
}

export default NatDisasterCommentEditDialog

const StyledDialogTitle = styled(DialogTitle)`
    &.MuiDialogTitle-root {
        padding: 17px 15px 17px 15px;
        border-bottom: 1px solid ${Colors.Background};
    }

    &.MuiTypography-h6 {
        color: ${Colors.AccentDark};
        font-size: 20px;
        font-family: ${FontFamily.ResidentDefault};
        font-weight: ${FontWeights.Bold};
    }
`

const StyledDialogContent = styled(DialogContent)`
    &.MuiDialogContent-root {
        padding: 15px 15px 15px 15px;
        flex-grow: 2;
    }
`

const CommentEditDialog = styled(ResponsiveDialog)`
    ${currentMedia.greaterThan('pc')`
    & .MuiDialog-paper {
        width: 580px;
    }
`}
`
